export default __webpack_public_path__ + "static/media/star_fill_green.db1c8dca.svg";